import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(LoadingService);

  if (loading.shouldSkip(req.url)) {
    return next(req);
  }

  loading.show();

  return next(req).pipe(
    finalize(() => loading.hide())
  );
};
